import React, { Component } from 'react';

const nl2br = require('react-nl2br');
// constants
import { MAGNITT_ACCESS_ROLES } from '/src/lib/constants/userRoles';

import { additionalQuestions } from '../Constants/formOptions';
import { renderLockedQuestionSection } from '../../LockedContent';


export default class QuestionsSection extends Component {

    renderQuestion = (questions, object) => {
        return questions.map((item, i) => {
            if (object[item.keyName]) {
                return (
                    <div className="info-box-container" key={i}>
                        <div className="info-box-title" data-toggle="collapse" href={"#faq-" + i} aria-expanded={i == 0 ? "true" : "false"}>
                            {item.question}
                        </div>
                        <div className={i == 0 ? "info-box-body collapse show" : "info-box-body collapse hide"} id={"faq-" + i}>
                            <div className='answers'>{nl2br(object[item.keyName])}</div>
                        </div>
                    </div>
                )
            }
        });
    }

    render() {

        const { object, user, sectionRef, setState, entityType } = this.props;
        const showQuestionsSection = (object.problem_solved || object.market_opportunity || object.competitors || object.monetization || object.challenges);
        const questions = additionalQuestions;
        const hasAccess = (user && user?.is_loggedin && (user?.roles.includes(MAGNITT_ACCESS_ROLES.directory_access) || user?.roles.includes(MAGNITT_ACCESS_ROLES.limited_directory_access)));

        if (!hasAccess) {
            return renderLockedQuestionSection(entityType, setState, sectionRef);
        }

        let content = null;
        if (__isBrowser__ && user.is_loggedin) {
            if (showQuestionsSection) {
                content =
                    <div className="mid-width-info-box profile-section-box question-section" ref={sectionRef} id="section-questions">
                        <h2 className="profile-section-heading">About this Startup</h2>
                        <div className="mid-width-info-box">
                            {this.renderQuestion(questions, object)}
                        </div>
                    </div>
            }
        }

        return content;

    }

}